import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "0",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_RefDt: new Date(), // dd/MM/yyyy
    A_Reason: "",
    A_Loc: "",
    A_LocName: "",
    A_Narr: "",
    A_DocStat: "ENTER",
  },
};

const SliceWmsStockAdjustment = createSlice({
  name: "SliceWmsStockAdjustment",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_WmsStockAdjustment_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_WmsStockAdjustment_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_WmsStockAdjustment_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },

    Wms_StockAdjustment_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.A_Reason = action.payload.A_Reason;
    },

    Set_StockAdjustment_HeadObject_A_VocNo: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    Set_StockAdjustment_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_WmsStockAdjustment_Init,
  Set_WmsStockAdjustment_HeadObject_Set,

  Wms_StockAdjustment_HeadObject_New_Set,
  Set_WmsStockAdjustment_HeadObject_Init,

  Set_StockAdjustment_HeadObject_A_VocNo,
  Set_StockAdjustment_HeadObject_A_DocStat,
} = SliceWmsStockAdjustment.actions;
export default SliceWmsStockAdjustment.reducer;
